<template>
    <div class="warehouse-info">
        <div class="title-container">
            <span class="sub-title">仓库信息</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="contentVisible">
            <vxe-table
                v-loading="loading"
                border
                size="mini"
                ref="tableRef"
                :data="tableData"
                :column-config="{ resizable: true }"
                show-overflow
                max-height="410"
            >
                <vxe-column field="whCode" title="仓库编码" width="100px"></vxe-column>
                <vxe-column field="operationType_" title="操作类型" width="100px"></vxe-column>
                <vxe-column field="companyName" title="分公司" width="150px"></vxe-column>
                <vxe-column field="cityName" title="城市" width="120px"></vxe-column>
                <vxe-column field="whName" title="仓库名称" width="150px"></vxe-column>
                <vxe-column field="whAddress" title="仓库地址" width="200"></vxe-column>
                <vxe-column field="rentableArea" title="剩余可租面积" width="110px"></vxe-column>
                <vxe-column field="lastRentableArea" title="上次更新可租面积" width="130px"></vxe-column>
                <vxe-column field="changeArea" title="面积变化" width="100px"></vxe-column>
                <vxe-column field="unitPrice" title="单价（元/平/月）" width="130px"></vxe-column>
                <vxe-column field="contacts" title="联系人" width="100px"></vxe-column>
                <vxe-column field="contactsPhone" title="联系电话" width="110px"></vxe-column>
                <vxe-column field="fireInspection_" title="消防验收" width="100px"></vxe-column>
                <vxe-column field="whType_" title="仓库类型" width="100px"></vxe-column>
                <vxe-column field="factorySign_" title="地产商简称" width="100px"></vxe-column>
                <vxe-column field="platform_" title="月台" width="100px"></vxe-column>
                <vxe-column field="canopy_" title="雨棚" width="100px"></vxe-column>
            </vxe-table>
            <div class="page">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="pageChange"
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                ></el-pagination>
            </div>
        </div>
        <div class="title-container" v-if="fileUrl">
            <span class="sub-title">附件</span>
        </div>
        <div v-if="fileUrl">
            <span class="file-name">{{ fileName }}</span>
            <el-button type="text" @click="handlePreview">查看</el-button>
            <el-button type="text" @click="handleDownload">下载</el-button>
        </div>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api'
import Preview from '../../../../components/viewAttachment.vue'
import { queryWarehousePage } from '../../../../api/storageSrcPool/warehouseSourceProcess.js'

export default {
    components: { Preview },
    props: {
        fdId: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            loading: false,
            dictData: {},
            tableData: [],
            totalCount: 0,
            pageNo: 1,
            pageSize: 10,
            pageConfig: {
                layout: 'total, sizes, prev, pager, next, jumper',
                pageSize: 10,
                pageSizes: [10, 30, 50, 100]
            },
            contentVisible: true,
            fileUrl: '',
            fileName: '',
            attachmentShow: false,
            attachmentList: [],
            rowData: {},
        }
    },
    methods: {
        loadData() {
            this.loading = true
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                fdId: this.fdId,
            }
            queryWarehousePage(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalCount = res.data.totalCount || 0
                        this.tableData = res.data.list.map(item => {
                            item.operationType_ = this.dictData.SOURCING_WAREHOUSE_OPERATION[item.operationType]
                            item.fireInspection_ = this.dictData.SYS_SU_FIRE_INSPECTION[item.fireInspection]
                            item.whType_ = this.dictData.SYS_SU_WH_TYPE[item.whType]
                            item.factorySign_ = this.dictData.SRM_WAREHOUSE_FACTORY_SIGN[item.factorySign]
                            item.platform_ = this.dictData.SYS_SU_PLATFORM[item.platform]
                            item.canopy_ = this.dictData.SYS_SU_CANOPY[item.canopy]
                            item.auditStatus_ = this.dictData.SRM_AUDIT_STATUS[item.auditStatus]
                            return item
                        })
                        if (res.data.list && res.data.list.length) {
                            this.fileUrl = res.data.list[0].fileUrl
                            this.fileName = res.data.list[0].fileName
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        pageChange(pageNo) {
            this.pageNo = pageNo;
            this.loadData();
        },
        sizeChange(pageSize) {
            this.pageNo = 1;
            this.pageSize = pageSize;
            this.loadData();
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
        handlePreview() {
            if (this.fileUrl) {
                this.rowData = {
                    downUrl: this.fileUrl,
                    fileName: this.fileName
                };
                this.attachmentShow = true;
            } else {
                this.$message.warning('暂无附件!')
            }
        },
        handleDownload() {
            if (this.fileUrl) {
                const a = document.createElement('a');
                a.href = this.fileUrl;
                a.download = this.fileName;
                a.click();
            } else {
                this.$message.warning('暂无附件!')
            }
        },
    },
    mounted() {
        dictWithUrl(
            'SRM_AUDIT_STATUS,SYS_SU_FIRE_INSPECTION,SYS_SU_WH_TYPE,SRM_WAREHOUSE_FACTORY_SIGN,SYS_SU_PLATFORM,' +
            'SYS_SU_CANOPY,SOURCING_WAREHOUSE_OPERATION'
        ).then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                this.loadData()
            }
        });
    }
}
</script>
<style lang="less" src="../../../../style/vxe-table-style.less"></style>
<style lang="less" scoped>
.title-container {
    margin-top: 15px;
    margin-bottom: 5px;

    i {
        float: right;
        padding-right: 10px;
        font-size: 24px;
        cursor: pointer;
    }
}
.page {
    margin-top: 10px;
    /deep/ .el-pagination {
        text-align: right;
    }
}
.file-name {
    font-size: 13px;
    display: inline-block;
    margin-right: 10px;
    color: #606266;
}
</style>